import React, { useEffect } from 'react';
import { Outlet, useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';

const AdminSettings = () => {
  const { checkPermission } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  const menuItems = [
    {
      name: 'Payment Settings',
      path: 'payment-settings',
      requiredPermission: 'View Payment Settings'
    },
    {
      name: 'Client Types',
      path: 'client-types',
      requiredPermission: 'View Client Types'
    },
    {
      name: 'Form Categories',
      path: 'form-categories',
      requiredPermission: 'View Form Categories'
    },
    {
      name: 'Custom Pages',
      path: 'custom-pages',
      requiredPermission: 'View Custom Pages'
    },
    {
      name: 'Custom Documents',
      path: 'custom-documents',
      requiredPermission: 'View Custom Page Documents'
    },
    {
      name: 'Custom Page Submissions',
      path: 'custom-menu-submissions',
      requiredPermission: 'View Custom Page Submissions'
    },
    {
      name: 'Upload Fields',
      path: 'upload-fields',
      requiredPermission: 'View Upload Fields'
    },
    {
      name: 'Verification Types',
      path: 'verification-types',
      requiredPermission: 'View Verification Types'
    },
    {
      name: 'Task Template',
      path: 'task-templates',
      requiredPermission: 'View Admin Settings'
    },
    {
      name: 'Products',
      path: 'products',
      requiredPermission: 'View Products'
    },
    {
      name: 'Email Gateways',
      path: 'email-gateways',
      requiredPermission: 'View Email Gateways'
    },
    {
      name: 'Email Templates',
      path: 'email-templates',
      requiredPermission: 'View Email Templates'
    },
    {
      name: 'Invoice Settings',
      path: 'invoice-settings',
      requiredPermission: 'View Invoice Settings'
    },
    {
      name: 'Admin Document Generation',
      path: 'admin-document-generation',
      requiredPermission: 'View Document Templates'
    },
    {
      name: 'Generate POA Document',
      path: 'poa-document-generator',
      requiredPermission: 'View Admin Settings'
    },
    {
      name: 'Custom ID Settings',
      path: 'custom-id-settings',
      requiredPermission: 'View Admin Settings'
    },
    {
      name: 'API Integration Settings',
      path: 'api-integration-settings',
      requiredPermission: 'View Admin Settings'
    },
    {
      name: 'Blocks',
      path: 'blocks',
      requiredPermission: 'View Blocks'
    },
    {
      name: 'Prefilling Settings',
      path: 'prefilling-settings',
      requiredPermission: 'View Admin Settings'
    },
    {
      name: 'Checklist Settings',
      path: 'checklist-settings',
      requiredPermission: 'View Admin Settings'
    }
  ];

  // Filter menu items based on permissions
  const filteredMenuItems = menuItems.filter(item => 
    checkPermission(item.requiredPermission)
  );

  // Redirect to first available menu item if no specific route is active
  useEffect(() => {
    if (location.pathname === '/admin/settings' && filteredMenuItems.length > 0) {
      navigate(filteredMenuItems[0].path, { replace: true });
    }
  }, [location.pathname, filteredMenuItems, navigate]);

  if (filteredMenuItems.length === 0) {
    return (
      <div className="flex items-center justify-center h-64">
        <div className="text-center">
          <h3 className="text-lg font-medium text-gray-900 mb-2">No Access</h3>
          <p className="text-gray-500">You don't have permission to access admin settings.</p>
        </div>
      </div>
    );
  }

  return (
    <div className="w-full">
      <Outlet />
    </div>
  );
};

export default AdminSettings; 